/**
 * Checks if the current date is within the December festive period
 * Festive period: November 25 - January 5
 * @returns true if current date is within the festive period, false otherwise
 */
export function isFestivePeriod(): boolean {
  const now = new Date();
  const month = now.getMonth(); // 0-indexed (0 = January, 11 = December)
  const date = now.getDate();

  // November 25 - November 30
  if (month === 10 && date >= 25) {
    return true;
  }

  // December 1 - December 31
  if (month === 11) {
    return true;
  }

  // January 1 - January 5
  if (month === 0 && date <= 5) {
    return true;
  }

  return false;
}
